// extracted by mini-css-extract-plugin
export var settingsPro = "ProStatus-module__settingsPro___np2eZ";
export var subtitle = "ProStatus-module__subtitle___YsaV6";